import { render, staticRenderFns } from "./VesselSisterShip.vue?vue&type=template&id=7fcc1790&scoped=true&"
import script from "./VesselSisterShip.vue?vue&type=script&lang=js&"
export * from "./VesselSisterShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc1790",
  null
  
)

export default component.exports